module.exports = __webpack_public_path__ + "img/angle_240.6daa7bca.jpg";